import React, { type ReactNode } from 'react';

import { FormattedMessage } from 'react-intl-next';

import {
	CommonErrorStateWrapper,
	ErrorStateSmallLink,
	SmallErrorStateHeading,
	SmallErrorStateImage,
	SmallErrorStateTextWrapper,
} from '../error-state/styled';

type SmallErrorStateProps = {
	itemId: string;
	image: SVGElement | string;
	link?: string;
	heading: Record<string, ReactNode>;
	subheading?: Record<string, ReactNode>;
	itemHeight: number;
	isInViewMode: boolean;
	hideLink?: boolean;
	isSelected?: boolean;
	isNavigationThumbnail?: boolean;
	minWidth?: number;
};

export const SmallErrorState = ({
	itemId,
	image,
	heading,
	subheading,
	itemHeight,
	link,
	isInViewMode,
	hideLink,
	isSelected,
	isNavigationThumbnail,
	minWidth,
}: SmallErrorStateProps) => {
	return (
		<CommonErrorStateWrapper
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className="small-error-state"
			id={itemId}
			itemHeight={itemHeight}
			isInViewMode={isInViewMode}
			isSelected={isSelected}
			isNavigationThumbnail={isNavigationThumbnail}
			minWidth={minWidth}
		>
			<SmallErrorStateImage src={image} />
			<SmallErrorStateTextWrapper>
				<SmallErrorStateHeading>
					<FormattedMessage {...heading} />
				</SmallErrorStateHeading>
				{!!subheading && !hideLink && (
					<ErrorStateSmallLink href={link} target="_blank">
						<FormattedMessage {...subheading} />
					</ErrorStateSmallLink>
				)}
			</SmallErrorStateTextWrapper>
		</CommonErrorStateWrapper>
	);
};
